import { ImageSize } from 'types/isomorphic';

/**
 * True when the /download-sizes entries carry a `teeShirtSize` tag — the
 * signature of an "extend" edit, whose modified sizes are tiered against the
 * original image's tee-shirt sizes. Fibo/pre-shot edits emit resolution-only
 * sizes (low/medium/high aka 1k/2k/4k) with no teeShirtSize. The tag is
 * uniform per generation, so any entry is a sufficient signal.
 *
 * Extend sizes are never gated by the UltraPack tier (there is no per-tier
 * extend offering), so ModifiedBuyCard and the download buttons all use this
 * predicate to pass them through `restrictModifiedSizesForPackTier` untouched
 * — one source, so the UI and the GA4 asset_sizes list cannot drift.
 */
const isExtendEdit = (sizes?: ImageSize[]): boolean =>
  (sizes ?? []).some((size) => Boolean(size.teeShirtSize));

export default isExtendEdit;
